import { OrderStatusCON } from './style';
import { formatCurrency } from '../../utils/currencyFormater';
import { AdminOrderActions } from '../../actions/Admin/Order';
import { formatDate } from '../../utils/dateFormater';
import StatusDot from '../../components/atoms/StatusDot';
import { AdminCompletedOrderActions } from '../../actions/Admin/Order/Completed';
import { OrderActions } from '../../actions';

export const filter = [
  {
    label: 'All Orders',
    value: 'ALL'
  },
  {
    label: 'Pending Orders',
    value: 'PENDING'
  },
  {
    label: 'Ongoing Orders',
    value: 'ONGOING'
  },

  {
    label: 'Cancelled Orders',
    value: 'CANCELLED'
  },

  {
    label: 'Completed Orders',
    value: 'COMPLETED'
  }
];

export const RecentOrderColumn = [
  {
    id: 0,
    field: 'id',
    headerName: 'ID',
    flex: 1,
    minWidth: 100
  },

  {
    id: 2,
    field: 'customer',
    headerName: "Customer's Name",
    flex: 1,
    minWidth: 100,
    renderCell: ({ row }: any) => {
      console.log(row);
      return (
        <p>
          {row?.customer?.firstname} {row?.customer?.lastname}
        </p>
      );
    }
  },
  {
    id: 3,
    field: 'vendorName',
    headerName: "Vendor's Name",
    flex: 1,
    minWidth: 200,
    renderCell: ({ row }: any) => <p>{row?.vendorName}</p>
  },

  {
    id: 4,
    field: 'orderItemQuantity',
    headerName: 'No of Items',
    flex: 1,
    minWidth: 100,
    renderCell: ({ row }: any) => <p>{row?.orderItemQuantity}</p>
  },
  {
    id: 5,
    field: 'orderDate',
    headerName: 'Order Date',
    flex: 2,
    minWidth: 200,
    renderCell: ({ row }: any) => <p>{formatDate(row?.orderDate)}</p>
  },

  {
    id: 6,
    field: 'price',
    headerName: 'Price',
    flex: 1,
    minWidth: 100,
    renderCell: ({ row }: any) => <p>{formatCurrency(row?.totalAmount)}</p>
  },
  {
    id: 7,
    field: 'deliveryMethod',
    headerName: 'Delivery Type',
    flex: 1,
    minWidth: 100,
    renderCell: ({ row }: any) => <p>{row?.deliveryMethod}</p>
  },
  {
    id: 8,
    field: 'status',
    headerName: 'Status',
    flex: 1,
    minWidth: 100,
    renderCell: ({ row }: any) => (
      <OrderStatusCON status={row?.orderStatus.toLowerCase()}>
        <p>{row?.orderStatus === 'cancelled' ? 'Canceled' : row?.orderStatus}</p>
      </OrderStatusCON>
    )
  },
  // {
  //   id: 8,
  //   field: 'deliveryStatus',
  //   headerName: 'Delivery Status',
  //   flex: 1,
  //   minWidth: 100,
  //   renderCell: ({ row }: any) => (
  //     <OrderStatusCON status={row?.deliveryStatus.toLowerCase()}>
  //       <p>{row?.deliveryStatus === 'cancelled' ? 'Canceled' : row?.deliveryStatus}</p>
  //     </OrderStatusCON>
  //   )
  // },
  // {
  //   id: 8,
  //   field: 'paymentStatus',
  //   headerName: 'Payment Status',
  //   flex: 1,
  //   minWidth: 100,
  //   renderCell: ({ row }: any) => (
  //     <OrderStatusCON status={row?.paymentStatus.toLowerCase()}>
  //       <p>{row?.paymentStatus === 'cancelled' ? 'Canceled' : row?.paymentStatus}</p>
  //     </OrderStatusCON>
  //   )
  // },

  {
    id: 9,
    field: 'action',
    headerName: 'Action',
    flex: 1,
    minWidth: 100,
    renderCell: ({ row }: any) => <OrderActions order={row?.id} />
  }
];

export const completedOrderColumn = [
  {
    id: 1,
    field: 'orderRef',
    headerName: 'Order ID',
    flex: 1,
    minWidth: 150
  },

  {
    id: 2,
    field: 'name',
    headerName: "Customer's Name",
    flex: 1,
    minWidth: 100,
    renderCell: ({ row }: any) => (
      <p>
        {row?.customer?.firstname} {row?.customer?.lastname}
      </p>
    )
  },

  {
    id: 3,
    field: 'orderItemQuantity',
    headerName: 'No of Items',
    flex: 1,
    minWidth: 100
  },

  {
    id: 4,
    field: 'orderDate',
    headerName: 'Order Date',
    flex: 1,
    minWidth: 100
  },

  {
    id: 5,
    field: 'deliveryMethod',
    headerName: 'Delivery Type',
    flex: 1,
    minWidth: 100,
    renderCell: ({ row }: any) => (
      <p
        style={{
          textTransform: 'capitalize'
        }}>
        {row.deliveryMethod}
      </p>
    )
  },

  {
    id: 6,
    field: 'totalAmount',
    headerName: 'Total Amount',
    flex: 1,
    minWidth: 100,
    renderCell: ({ row }: any) => <p>{formatCurrency(row?.totalAmount)}</p>
  },

  {
    id: 4,
    field: 'timeTaken',
    headerName: 'Time Taken',
    flex: 1,
    minWidth: 100,
    renderCell: ({ row }: any) => <p>N/A</p>
  },

  {
    id: 8,
    field: 'action',
    headerName: 'Action',
    flex: 1,
    minWidth: 100,
    renderCell: ({ row }: any) => <AdminCompletedOrderActions status={row.status} order={row.id} />
  }
];
